import { Box, SxProps, Theme, useTheme } from '@mui/material'

export type TextToggleProps = {
  state: boolean
  onText: string
  offText: string
  onClick: () => void
  sx?: SxProps<Theme>
}

export function TextToggle(props: TextToggleProps): React.ReactElement {

  const { state, onText, offText, sx, onClick } = props
  const theme = useTheme()

  return (
    <Box
      display="inline-block"
      onClick={onClick}
      data-cy={`toggle-${onText}`}
      sx={{
        color: theme.palette.grey[500],
        fontWeight: 600,
        lineHeight: '1rem',
        textDecoration: 'underline',
        cursor: 'pointer',
        userSelect: 'none',
        ...sx
      }}
    >
      {!state ? onText : offText}
    </Box>
  )
}
